import { BASEURL, checktoken, headers } from '../../utils/helper'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError, toastSuccess } from './other.slice';
import axios from 'axios';

const initialState = {
    data: [],
    error: null,
    sidebar: true,
    insurance: {},
    insurances: [],
    pages: 0,
    total: 0,
    current: 0,
    loading: false,
}

export const InsuranceListByStatus = createAsyncThunk('InsuranceListByStatus', async ({ status, page }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/insurance/list/${status}?page=${page}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const InsuranceList = createAsyncThunk('InsuranceList', async ({ role }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/insurance/list/${role}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const InsuranceDelete = createAsyncThunk('InsuranceDelete', async ({ role, id, page }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.delete(`${BASEURL}/admin/insurance/delete/${id}`,
            { headers: headers() })
            .then((res) => {
                if (res?.data?.success) {
                    dispatch(toastSuccess(res?.data?.message))
                    dispatch(InsuranceList({ role: role, page: page ? page : 1 }))
                }
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const singleInsuranceReq = createAsyncThunk('singleInsuranceReq', async ({ id }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/insurance/info/${id}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const insuranceFormSlice = createSlice({
    name: 'insuranceFormSlice',
    initialState: initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder.addCase(InsuranceList.pending, (state, action) => {
            state.loading = true
            state.data = []
            return state
        })
        builder.addCase(InsuranceList.fulfilled, (state, action) => {
            state.loading = false
            state.data = action.payload.data
            return state
        })
        builder.addCase(InsuranceList.rejected, (state, action) => {
            state.loading = false
            state.data = []
            state.error = 'Error occured'
        })

        builder.addCase(singleInsuranceReq.pending, (state, action) => {
            state.loading = true
            state.insurance = {}
            return state
        })
        builder.addCase(singleInsuranceReq.fulfilled, (state, action) => {
            state.loading = false
            state.insurance = action.payload.data
            return state
        })
        builder.addCase(singleInsuranceReq.rejected, (state, action) => {
            state.loading = false
            state.insurance = {}
            state.error = 'Error occured'
        })

        builder.addCase(InsuranceListByStatus.pending, (state, action) => {
            state.loading = true
            state.pages = 0
            state.total = 0
            state.current = 0
            state.insurances = []
            return state
        })
        builder.addCase(InsuranceListByStatus.fulfilled, (state, action) => {
            state.loading = false
            state.pages = action.payload.data?.pages
            state.total = action.payload.data?.total
            state.current = action.payload.data?.current
            state.insurances = action.payload.data?.insurance
            return state
        })
        builder.addCase(InsuranceListByStatus.rejected, (state, action) => {
            state.loading = false
            state.pages = 0
            state.total = 0
            state.current = 0
            state.insurances = []
            state.error = 'Error occured'
        })
        builder.addCase('LOGOUT', () => initialState)
    }
})

export default insuranceFormSlice.reducer